export default "__VITE_ASSET__OFmxW3Ij__"